import { ThemeLayout } from '../../front/lib/ThemeLayout';
export class SingleArticle extends ThemeLayout {
    constructor() {
        super(...arguments);
        this.contentEl = this.getElementById('content');
    }
    init() {
        const advertInsertEl = this.getElementById('advertInsert');
        if (advertInsertEl) {
            this.insertAdvert(advertInsertEl);
        }
    }
    insertAdvert(srcEl) {
        var _a;
        (_a = srcEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(srcEl);
        const data = JSON.parse(srcEl.innerText);
        if (!data.html) {
            console.warn('Advert data is empty', data);
            return;
        }
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data.html;
        // Find the middle point of the content
        // and insert the advert there
        const contentEls = [].slice.apply(this.contentEl.children).reduce((acc, el) => {
            if (el.classList.contains('wpClassicContent')) {
                acc.push(...[].slice.apply(el.children));
            }
            else {
                acc.push(el);
            }
            return acc;
        }, []);
        const middlePoint = Math.floor(this.contentEl.innerText.length / 2);
        let contentLength = 0;
        let insertPoint;
        for (const el of contentEls) {
            if (contentLength > middlePoint) {
                insertPoint = el;
                break;
            }
            contentLength += el.innerText.length;
        }
        if (insertPoint) {
            insertPoint.insertAdjacentElement('beforebegin', tempDiv.firstElementChild);
        }
        else {
            this.contentEl.appendChild(tempDiv.firstElementChild);
        }
    }
}
